(() => {
	const initializeCollectionTabs = (root) => {
		root.querySelectorAll('.tce-microsite-collection-tabs').forEach((tabs) => {
			if (tabs.dataset.tceTabsReady === 'true') return

			const triggers = tabs.querySelectorAll('[data-tab-trigger]')
			const boxes = tabs.querySelectorAll('[data-box]')

			triggers.forEach((trigger) => {
				trigger.addEventListener('click', (event) => {
					event.preventDefault()
					const targetId = trigger.dataset.tabTrigger

					triggers.forEach((item) => item.classList.toggle('is-active', item === trigger))
					boxes.forEach((box) => {
						const isTarget = box.dataset.box === targetId
						box.classList.toggle('l-hidden', !isTarget)
						box.setAttribute('aria-hidden', String(!isTarget))

						if (isTarget) box.removeAttribute('tabindex')
						else box.setAttribute('tabindex', '-1')
					})
				})
			})

			tabs.dataset.tceTabsReady = 'true'
		})
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => initializeCollectionTabs(document))
	} else {
		initializeCollectionTabs(document)
	}

	document.addEventListener('shopify:section:load', (event) => initializeCollectionTabs(event.target))
})()
